module.exports = __webpack_public_path__ + "media/bootstrap-icons/building-cfb55557.svg";